import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/auth';

const ParentBulletins = () => {
  const navigate = useNavigate();
  const [children, setChildren] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);
  const [bulletins, setBulletins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchChildren();
  }, []);

  useEffect(() => {
    if (selectedChild) {
      fetchBulletins(selectedChild);
    }
  }, [selectedChild]);

  const fetchChildren = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get('/parent/children', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const list = Array.isArray(res.data) ? res.data : (res.data.children || res.data.data || []);
      setChildren(list);
      if (list.length > 0) {
        setSelectedChild(list[0].id);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error('Erreur:', err);
      setError(err.response?.data?.error || 'Erreur lors du chargement');
      setLoading(false);
    }
  };

  const fetchBulletins = async (childId) => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');
      const res = await api.get(`/parent/children/${childId}/report-cards`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBulletins(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur bulletins:', err);
      setBulletins([]);
    } finally {
      setLoading(false);
    }
  };

  const getAverageColor = (avg) => {
    if (avg >= 16) return 'text-green-600';
    if (avg >= 14) return 'text-blue-600';
    if (avg >= 12) return 'text-yellow-600';
    if (avg >= 10) return 'text-orange-600';
    return 'text-red-600';
  };

  return (
    <div className="p-6 lg:p-8 bg-white min-h-screen">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-[#0A0A0A]">📊 Bulletins</h1>
        <p className="text-gray-500 mt-1">Consultez les bulletins de vos enfants</p>
      </div>

      {children.length > 1 && (
        <div className="mb-6 flex gap-2 flex-wrap">
          {children.map((c) => (
            <button
              key={c.id}
              onClick={() => setSelectedChild(c.id)}
              className={`px-4 py-2 rounded-xl text-sm font-medium transition ${
                selectedChild === c.id
                  ? 'bg-[#F39C12] text-white shadow-md'
                  : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>
      )}

      {loading ? (
        <div className="text-center py-20 text-gray-500">Chargement...</div>
      ) : bulletins.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-12 text-center">
          <p className="text-5xl mb-3">📊</p>
          <p className="text-lg font-bold text-[#0A0A0A] mb-2">Aucun bulletin disponible</p>
          <p className="text-sm text-gray-500">Les bulletins apparaîtront ici une fois publiés.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {bulletins.map((b) => (
            <div
              key={b.id}
              className="bg-white rounded-2xl border border-gray-100 p-5 hover:shadow-md transition cursor-pointer"
              onClick={() => setSelected(b)}
            >
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="text-lg font-bold text-[#2C3E50]">📄 {b.period_label}</h3>
                  <p className="text-sm text-gray-500">{b.academic_year} — {b.class_name}</p>
                </div>
                <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">🟢 Validé</span>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-blue-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Moyenne</p>
                  <p className={`text-2xl font-bold ${getAverageColor(b.general_average)}`}>
                    {b.general_average?.toFixed(2)}/20
                  </p>
                </div>
                <div className="bg-green-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Rang</p>
                  <p className="text-2xl font-bold text-green-600">{b.rank}/{b.total_students}</p>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-3">Publié le {b.published_at}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ParentBulletins;